module.exports = __webpack_public_path__ + "static/media/katrineholm_3.012299c9.jpg";